"use client"

import Link from "next/link"
import { motion } from "framer-motion"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Home, Search, ArrowLeft } from "lucide-react"
import GradientBackground from "@/components/animated/gradient-background"

export default function NotFound() {
  return (
    <div className="min-h-screen relative flex items-center justify-center">
      <GradientBackground />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <Card className="bg-white/80 backdrop-blur-sm border-0 shadow-2xl max-w-2xl mx-auto">
            <CardContent className="p-12">
              <motion.div
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="mb-8"
              >
                <div className="text-8xl font-bold text-slate-300 mb-4">404</div>
                <h1 className="text-3xl font-bold text-slate-900 mb-4">Page Not Found</h1>
                <p className="text-lg text-slate-600 mb-8">
                  Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or you entered
                  the wrong URL.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="space-y-4"
              >
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button asChild size="lg" className="bg-gradient-to-r from-slate-900 to-slate-700">
                    <Link href="/">
                      <Home className="h-5 w-5 mr-2" />
                      Go Home
                    </Link>
                  </Button>
                  <Button asChild size="lg" variant="outline">
                    <Link href="/products">
                      <Search className="h-5 w-5 mr-2" />
                      Browse Products
                    </Link>
                  </Button>
                </div>

                <Button asChild variant="ghost" className="w-full">
                  <Link href="javascript:history.back()">
                    <ArrowLeft className="h-4 w-4 mr-2" />
                    Go Back
                  </Link>
                </Button>
              </motion.div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  )
}
